export default __webpack_public_path__ + "static/media/globo.7884cd99.jpg";